import { motion } from 'motion/react';
import { HeartHandshake, RotateCcw, Mail } from 'lucide-react';
import { theme } from '../../styles/theme';
import { useIsMobile } from '../../hooks/useIsMobile';
import { ConnieAvatar } from '../../components/ConnieAvatar';

interface GoodbyePanelProps {
  destination: string;
  onRestart: () => void;
}

export function GoodbyePanel({ destination, onRestart }: GoodbyePanelProps) {
  const mobile = useIsMobile();
  return (
    <div style={{ maxWidth: '36rem', margin: '0 auto', textAlign: 'center', padding: mobile ? '2rem 1rem' : '5rem 1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: mobile ? '1.5rem' : '3rem' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <div style={{ position: 'absolute', inset: 0, background: `${theme.colors.teal}33`, filter: 'blur(48px)', borderRadius: '50%' }} />
        <ConnieAvatar size={mobile ? 120 : 192} style={{
          position: 'relative',
          boxShadow: theme.shadows.xl, border: `4px solid ${theme.colors.tealBorder}`,
          padding: 8,
        }} />
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, type: 'spring' }}
          style={{
            position: 'absolute', bottom: mobile ? -12 : -16, right: mobile ? -12 : -16,
            width: mobile ? 48 : 64, height: mobile ? 48 : 64, background: theme.colors.teal, color: 'white',
            borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: theme.shadows.xl,
          }}
        >
          <HeartHandshake size={mobile ? 24 : 32} />
        </motion.div>
      </div>

      <div>
        <h2 style={{ fontFamily: theme.fontFamily.display, fontSize: mobile ? theme.fontSize['2xl'] : theme.fontSize['3xl'], fontWeight: theme.fontWeight.light, color: theme.colors.navy }}>
          Safe Travels!
        </h2>
        <div style={{ maxWidth: '28rem', margin: `${theme.spacing.xl} auto 0` }}>
          <p style={{ color: theme.colors.textMuted, fontSize: theme.fontSize.lg, fontWeight: theme.fontWeight.light, lineHeight: 1.6 }}>
            It has been a magical honor to help you plan your journey to <span style={{ fontWeight: theme.fontWeight.bold, color: theme.colors.navy }}>{destination}</span>.
          </p>
          <div style={{
            marginTop: theme.spacing.lg, padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
            background: theme.colors.tealBg, border: `1px solid ${theme.colors.tealBorder}`,
            borderRadius: theme.borderRadius.xl,
          }}>
            <p style={{ color: theme.colors.navy, fontWeight: theme.fontWeight.medium, lineHeight: 1.6, margin: 0 }}>
              Magic is better when it's built for business. Check your inbox for an email to schedule a meeting and see the AWS-validated architecture that brought me to life.
            </p>
          </div>
        </div>
      </div>

      <button className="btn-primary" onClick={onRestart} style={{
        padding: `${theme.spacing.xl} ${theme.spacing['3xl']}`,
        fontSize: theme.fontSize.xs,
        textTransform: 'uppercase', letterSpacing: '0.15em',
        display: 'flex', alignItems: 'center', gap: theme.spacing.md,
      }}>
        <RotateCcw size={16} /> Start a New Adventure
      </button>
    </div>
  );
}
